import { FC, useEffect, useRef } from 'react';

import {
  InjectedModule,
  usePostman,
  createCustomContext,
} from '@beeline/lk-utils';

import { APP_HELPDESK_WIDGET_URL } from ':constants';
import { serviceTrackEvent } from ':utils/analytics';

const widgetName = 'template-form-widget';
const widgetHost = APP_HELPDESK_WIDGET_URL;

export type TargetTemplate = {
  id?: string;
  extra?: any;
};

type TemplateFormWidgetProps = {
  targetTemplate?: TargetTemplate;
  consumerName: string;
  onError?: () => void;
};

export const TemplateFormWidget: FC<TemplateFormWidgetProps> = ({
  targetTemplate,
  consumerName,
  onError,
}) => {
  const postman = usePostman();

  const widgetParams = useRef({
    consumerName,
    widgetType: 'sidesheet-modal',
    widgetOptions: {
      divider: 'left',
      hasOverlay: true,
      onSubmitSuccess: () => {
        serviceTrackEvent('helpdesk_request', 'request_created_event');
      },
      onSubmitError: () => {
        serviceTrackEvent('helpdesk_request', 'request_error_event');
      },
      onClose: () => {
        serviceTrackEvent('helpdesk_request', 'modal_close_event');
      },
    },
    templateId: targetTemplate?.id,
    templateExtra: targetTemplate?.extra,
  });

  createCustomContext({
    templateFormWidget: widgetParams.current,
  });

  useEffect(() => {
    if (postman) {
      postman.send('templateFormWidget', {
        ...widgetParams.current,
        templateId: targetTemplate?.id,
        templateExtra: targetTemplate?.extra,
      });
    }
  }, [postman, targetTemplate]);

  return (
    <InjectedModule
      mode='closed'
      name={widgetName}
      host={widgetHost ?? ''}
      containerStyle={{ height: '100%' }}
      onError={onError}
      // disable standart fallback and error element
      fallback={<></>}
      errorElement={() => <></>}
    />
  );
};
